import { RFPD } from './../Model/RFPD.Model';
import { PromoSpend } from './../Model/PromoSpend.Modal';
import { PromoScope } from './../Model/PromoScope.Model';
import { PromoScopeCompetitor } from './../Model/PromoScopeCompetitor.Model';
import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ExcelService } from './ExcelService .service';
import { Router } from '@angular/router';
import { Banner } from '../Model/Banner.model';
import { MarketCompany } from '../Model/MarketCompany.Model';
import { Duties } from '../Model/Duties.Model';
import { BannerName } from '../Model/BannerName';
import { brand } from '../Model/brand';
import { BrandQuality } from '../Model/BrandQuality.Model';
import { BrandQualityCompetitor } from '../Model/BrandQualityCompetitor.Model';
import { ProductCompetitor } from '../Model/ProductCompetitor.Model';
import { customer } from '../Model/customer';
import { PromotedVolume } from '../Model/PromotedVolume.Model';
import { PromoType } from '../Model/PromoType';
import { PromoMultiple } from '../Model/PromoMultiples.Model';
import { ShopperType } from '../Model/ShopperType';
import { DailyRos } from '../Model/DailyRos.Model';
import { MarketCompanyDisplayUnit } from '../Model/MarketCompanyDisplayUnit.Model';
import { RoundDepthOption } from '../Model/RoundDepthOption.Model';
import { Currency } from '../Model/Currency';
import { DateFormat } from '../Model/DateFormat';
import { ShopperOfferGroup } from '../Model/ShopperOfferGroup';
import { Seasonality } from '../Model/Seasonality.model';
import { Multiple } from '../Model/Multiple';
import { PromoDepth } from '../Model/PromoDepth.Model';
import { PromoFundindRange } from '../Model/PromoFundingRange.Model';
import { SeasonalityCategory } from '../Model/SeasonalityCategory';
import { PeriodicityEpos } from '../Model/PeriodicityEpos';
import { ProductCategory } from '../Model/ProductCategory';
import { EposExclusionManagement } from '../Model/EposExclusionManagement';
import { Epos } from '../Model/Epos.Model';
import { EPOSCompetitor } from '../Model/EposCompitetor.Model';
import { Cogs } from '../Model/Cogs.Model';
import { DistributorPrice } from '../Model/DistributorPrice';
import { Handling } from '../Model/Handling.Model';
import { PromoDetectionTHreshold } from '../Model/PromoDetectionTHreshold.Model';
import { RSP } from '../Model/RSP';
import { Ratio } from '../Model/Ratio';
import { RegionnalBanner } from '../Model/RegionnalBanner.Model';
import { Product } from '../Model/Product.model';
import { Vat } from '../Model/Vat.Model';
import { AdditionalCostLiter } from '../Model/AdditionaCostLiter.Model';
import { AdditionalTaxLiter } from '../Model/AdditionaTaxLiter.Model';
import { Spds } from '../Model/Spds.Model';
import { RetailerMargin } from '../Model/RetailerMargin.Model';
import { RSPCompetitor } from '../Model/RSPCompetitor';
import { EposExclusionManagementCompetitor } from '../Model/EposExclusionManagementCompetitor';
import { brandCompetitor } from '../Model/brandCompetitor';
import { EposFirstDay } from '../Model/EposFirstDay.Model';

@Injectable({
  providedIn: 'root'
})
export class GenericService {
  public ListBanner: Banner[] = [];
  public ListBannerEposManagment: Banner[] = [];
  public ListBannerNames: BannerName[] = [];
  public ListBannerNamesMarketCo: BannerName[] = [];
  public ListMarketCompany: MarketCompany[] = [];
  public ListDuties: Duties[] = [];
  public ListSpds: Spds[] = [];
  public ListVats: Vat[] = [];
  public ListRetailers: RetailerMargin[] = [];
  public ListAdditionalCostLiter: AdditionalCostLiter[] = [];
  public ListAdditionalTaxLiter: AdditionalTaxLiter[] = [];
  public ListBrandQualities: BrandQuality[] = [];
  public ListBrandQualitiesPromoted: BrandQuality[] = [];
  public ListBrandQualitiesForOutliers: BrandQuality[] = [];
  public ListBrandQualitiesCompeting: BrandQuality[] = [];
  public ListBrandQualitiesCompitetor: BrandQualityCompetitor[] = [];
  public ListProductCompetitor: ProductCompetitor[] = [];
  public Listcustomer: customer[] = [];
  public ListPromotedVolumes: PromotedVolume[] = [];
  public ListPromoTypes: PromoType[] = [];
  public ListPromoMultiples: PromoMultiple[] = [];
  public ListShopperTypes: ShopperType[] = [];
  public ListDailyRoss: DailyRos[] = [];
  public ListEposFirstDay: EposFirstDay[] = [];
  public ListMarketCompanyDisplayUnits: MarketCompanyDisplayUnit[] = [];
  public ListRoundDepthOptions: RoundDepthOption[] = [];
  public Listcurrency: Currency[] = [];
  public ListdateFormat: DateFormat[] = [];
  public ListShopperOfferGroups: ShopperOfferGroup[] = [];
  public ListSeasonalities: Seasonality[] = [];
  public ListMultiples: Multiple[] = [];
  public ListPromoDepths: PromoDepth[] = [];
  public ListPromoFundindRanges: PromoFundindRange[] = [];
  public ListBrands: brand[] = [];
  public ListBrandsCompetitor: brandCompetitor[] = [];
  public ListSeasonalityCategory: SeasonalityCategory[] = [];
  public ListPeriodicityEpos: PeriodicityEpos[] = [];
  public ListProductCategory: ProductCategory[] = [];
  public ListEposExclusionManagement: EposExclusionManagement[] = [];
  public ListEpos: Epos[] = [];
  public ListEposCompetitor: EPOSCompetitor[] = [];
  public ListCogs: Cogs[] = [];
  public ListDistributorPrices: DistributorPrice[] = [];
  public ListHandling: Handling[] = [];
  public ListPromoScope: PromoScope[] = [];
  public ListPromoScopeCompetitor: PromoScopeCompetitor[] = [];
  public ListPromoSpend: PromoSpend[] = [];
  public ListRFPD: RFPD[] = [];
  public ListPromoDetecTH: PromoDetectionTHreshold[] = [];
  public ListRSP: RSP[] = [];
  public ListRatio: Ratio[] = [];
  public ListRegionnalBanner: RegionnalBanner[] = [];
  public ListProducts: Product[] = [];
  public ListBrandsForOutliers: brand[] = [];
  public listDutyBT: any[] = [];
  public ListRSPCompetitor: RSPCompetitor[] = [];
  public ListCompetitorEposExclusionManagement: EposExclusionManagementCompetitor[] = [];
  attttributeChange: EventEmitter<number> = new EventEmitter();


  constructor(
    private _http: HttpClient,
    private excelService: ExcelService,
    private router: Router
  ) { }

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('access_token');
    return new HttpHeaders({
      Authorization: 'Bearer ' + token
    });
  }
  
    // Reset all lists to empty arrays
  public resetAllList(): void {
    const lists = [
      'ListBanner', 'ListBannerEposManagment', 'ListBannerNames', 'ListBannerNamesMarketCo', 'ListMarketCompany',
      'ListDuties', 'ListSpds', 'ListVats', 'ListRetailers', 'ListAdditionalCostLiter', 'ListAdditionalTaxLiter',
      'ListBrandQualities', 'ListBrandQualitiesPromoted', 'ListBrandQualitiesForOutliers', 'ListBrandQualitiesCompeting',
      'ListBrandQualitiesCompitetor', 'ListProductCompetitor', 'Listcustomer', 'ListPromotedVolumes', 'ListPromoTypes',
      'ListPromoMultiples', 'ListShopperTypes', 'ListDailyRoss', 'ListEposFirstDay', 'ListMarketCompanyDisplayUnits',
      'ListRoundDepthOptions', 'Listcurrency', 'ListdateFormat', 'ListShopperOfferGroups', 'ListSeasonalities',
      'ListMultiples', 'ListPromoDepths', 'ListPromoFundindRanges', 'ListBrands', 'ListSeasonalityCategory',
      'ListPeriodicityEpos', 'ListProductCategory', 'ListEposExclusionManagement', 'ListEpos', 'ListEposCompetitor',
      'ListCogs', 'ListDistributorPrices', 'ListHandling', 'ListPromoScope', 'ListPromoScopeCompetitor', 'ListPromoSpend',
      'ListRFPD', 'ListPromoDetecTH', 'ListRatio', 'ListRegionnalBanner', 'ListRSP', 'ListProducts', 'ListBrandsForOutliers'
    ];
    lists.forEach(list => this[list] = []);

  }

  // HTTP GET
  public get(url: string, userToken: boolean = true): Observable<any> {
    const httpOptions = userToken ? { headers: this.getAuthHeaders() } : {};
    return this._http.get(url, httpOptions);
  }

  // HTTP POST
  public post(url: string, model: any, hasTextResponseType: boolean = false): Observable<any> {
    const httpOptions = {
      headers: this.getAuthHeaders(),
      responseType: hasTextResponseType ? 'text' as 'json' : undefined
    };
    return this._http.post(url, model, httpOptions);
  }

  // HTTP PUT
  public put(url: string, model: any): Observable<any> {
    const httpOptions = {
      headers: this.getAuthHeaders(),
      responseType: 'text' as 'json'
    };
    return this._http.put(url, model, httpOptions);
  }

  // HTTP GET by ID
  public getById(url: string, id: string): Observable<any> {
    const httpOptions = { headers: this.getAuthHeaders() };
    return this._http.get(url + id, httpOptions);
  }

  // HTTP DELETE
  public delete(url: string, id: string): Observable<any> {
    const httpOptions = { headers: this.getAuthHeaders() };
    return this._http.delete(url + id, httpOptions);
  }

  // Download File
  public downloadFile(url: string, userToken: boolean = true): Observable<any> {
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: this.getAuthHeaders()
    };
    return this._http.get(url, userToken ? httpOptions : {});
  }

  // Export methods
  export(model: any, name: string): void {
    this.excelService.exportAsExcelFile(model, name);
  }

  exportXls(model: any, name: string): void {
    this.excelService.exportAsXlsFile(model, name);
  }

  exportSheets(model: any, name: string): void {
    this.excelService.exportAsXlsSheets(model, name);
  }

  exportXlsUsers(model: any, name: string): void {
    this.excelService.generateSpecificExcelUsers(model, name);
  }

  // Emit attribute change
  emitAttributeChange(event: string): Subject<string> {
    let subject = new Subject<string>();
    subject.next(event);
    return subject;
  }

   //import
   import(event) {
    //this.excelService.FileUpload(event);
    //console.log("ok");
    //const file = event.target.files[0];
    //let reader: FileReader = new FileReader();
    //reader.readAsText(file);
    //reader.onload = (e) => {
    //  let blob = new Blob([reader.result], { type: "text/csv;charset=utf-8" });
    //  let csv: string = reader.result;
    //  console.log(blob);
    //  console.log(csv);
    //this.interfService.AddCRM(csv).subscribe();
    //}
  }


}
